
import { Component, Prop, Vue } from "vue-property-decorator";
import { CreateElement } from "vue";
import { TicketStatusMap } from "@/data/enums/tickets";
import { ITicket } from "@/models/tickets";

@Component
export default class TicketFlagTooltip extends Vue {
  // Props

  @Prop({ required: true })
  public ticket!: ITicket;

  // Computed

  public get status() {
    return TicketStatusMap()[this.ticket?.status?.code] || {};
  }

  public render(h: CreateElement) {
    return h(
      "b-tooltip",
      {
        props: {
          position: "is-right",
          ...this.status,
          ...this.$attrs
        }
      },
      [
        h("b-icon", {
          class: "is-size-8 has-cursor-help",
          props: {
            icon: "flag",
            size: "is-small",
            type: this.status.type
          }
        })
      ]
    );
  }
}
